import template from './hierarchical-payment-codes.html';
import {PAYMENT_CODES} from '../../../payment-codes-enum.js';
import {VALIDATION_OPTIONS} from '../../../payment-codes-enum.js';

const DIRECTIVE_NAME = HierarchicalPaymentCodes.DIRECTIVE_NAME = 'ktHierarchicalPaymentCodes';
export default function HierarchicalPaymentCodes() {
    return {
        restrict: 'A',
        template,
        bindToController: true,
        controller: HierarchicalPaymentCodesController,
        controllerAs: '$ctrl',
        scope: {
            model: `=${DIRECTIVE_NAME}`,
            suggestions: `=${DIRECTIVE_NAME}Suggestions`,
            tripId: `=${DIRECTIVE_NAME}TripId`,
        },
        link: ($scope, $elem, $attrs, $ctrl) => $ctrl.$onInit(),
    };
}

export function HierarchicalPaymentCodesController(
    $scope,
    paymentCodesListService,
    hierarchicalPaymentCodesService
) {
    'ngInject';
    const vm = this;
    const FORM_FIELDS = {
        ORGANISATION: 'organisation',
        PROJECT: 'project',
    };

    Object.assign(vm, {
        $onInit,
        isErrorMessageVisible,
        FORM_FIELDS,
        PAYMENT_CODES,
        VALIDATION_OPTIONS,
        onTaskCodeSelect,
        onAwardCodeSelect,
        valueOrDefault,
        onOrganizationDropdownChange,
        onProjectDropdownChange,
        getPaymentCodes: paymentCodesListService.getPaymentCodes,
        isDropdownHierarchical,
    });


    function onTaskCodeSelect() {
        vm.model.taskCode.Id = vm.taskCode.Id;
    }

    function onOrganizationDropdownChange(selected) {
        vm.model.organisation.Value = selected.Value;
    }

    function onProjectDropdownChange(selected) {
        vm.model.project.Value = selected.Value;
    }

    function isDropdownHierarchical(paymentCode) {
        if (!paymentCode) {
            return false;
        }
        if (paymentCode.PaymentCodeFieldTypeId) {
            return paymentCode.PaymentCodeValidationOption === VALIDATION_OPTIONS.DISPLAY_AS_DROPDOWN && paymentCode.PaymentCodeFieldTypeId === PAYMENT_CODES.HIERARCHICAL_CODES;
        }
        if (paymentCode.PaymentCodeFieldType) {
            return paymentCode.PaymentCodeFieldType.Id === PAYMENT_CODES.HIERARCHICAL_CODES && paymentCode.PaymentCodeFieldType.PaymentCodeDisplayValidationOption === VALIDATION_OPTIONS.DISPLAY_AS_DROPDOWN;
        }
    }

    function onAwardCodeSelect() {
        vm.model.awardCode.Id = vm.awardCode.Id;
    }

    function $onInit() {
        vm.paymentCodeData = {...vm.suggestions};
        vm.organizationValues = vm.paymentCodeData[0].DropDownValues.map((code) => ({Value: code}));
        vm.organizationValue = {Value: ''};
        vm.projectValue = {Value: ''};

        $scope.$watch(() => vm.model
            && vm.model.organisation
            && vm.model.organisation.Value, onOrganizationChange, true);
        $scope.$watch(() => vm.model
            && vm.model.project
            && vm.model.project.Value, onProjectChange, true);
    }

    function onOrganizationChange(newValue) {
        vm.childPaymentCode = {};
        Object.assign(vm.model, {
            project: {},
            taskCode: {},
            awardCode: {},
        });

        const {Value: value, Id: paymentCodeId, CustomerLabel} = vm.model.organisation;
        const {tripId} = vm;

        if (!newValue) {
            vm.model.organisation = {Id: paymentCodeId, CustomerLabel};
            return;
        }

        hierarchicalPaymentCodesService.validatePaymentCode({
            value,
            paymentCodeId,
            tripId,
        })
            .then((response) => {
                Object.assign(vm.model.organisation, response);

                if (response.IsValid) {
                    getChildPaymentCodes({
                        paymentCodeId,
                        parentPaymentCodeId: vm.model.organisation.SelectedValueId,
                    })
                        .then((data) => {
                            [vm.childPaymentCode] = data;
                            vm.model.project.Id = vm.childPaymentCode.Id;
                        });
                }
            });
    }

    function onProjectChange(value) {
        const Id = vm.childPaymentCode && vm.childPaymentCode.Id;
        if (!value) {
            vm.model.project = {Id};
            return;
        }
        hierarchicalPaymentCodesService.validatePaymentCode({
            value: vm.model.project.Value,
            paymentCodeId: vm.childPaymentCode.Id,
            parentPaymentCodeSelectedValueId: vm.model.organisation.SelectedValueId,
        })
            .then(setChildPaymentCodes);
    }

    function setChildPaymentCodes(response) {
        Object.assign(vm.model.project, response);
        if (response.IsValid) {
            getChildPaymentCodes({
                paymentCodeId: vm.childPaymentCode.Id,
                parentPaymentCodeId: vm.model.project.SelectedValueId,
            })
                .then(([task, award]) => {
                    vm.taskCode = task;
                    vm.awardCode = award;
                });
        }
    }

    function getChildPaymentCodes(paymentCode) {
        return hierarchicalPaymentCodesService.getChildPaymentCodes(paymentCode);
    }

    function valueOrDefault(input) {
        return input || 'n/a';
    }

    function isErrorMessageVisible(fieldName) {
        const field = vm.paymentCodesForm[fieldName];
        if (!field) {
            return false;
        }
        const {$touched, $dirty} = field;
        const {$submitted} = vm.paymentCodesForm;
        return $touched || $dirty || $submitted;
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/trip/payment-codes/payment-codes-container/payment-codes-list/hierarchical-payment-codes/hierarchical-payment-codes-component.js